/**
 * FeatureGate component.
 *
 * Conditionally renders children based on whether a feature is enabled.
 * Features are defined in regionConfig.features.
 *
 * Usage:
 *   <FeatureGate feature="pix">
 *     <PixPaymentButton />
 *   </FeatureGate>
 *
 *   <FeatureGate feature="tunaPayments" fallback={<p>Not available</p>}>
 *     <TunaConfig />
 *   </FeatureGate>
 */
import { isFeatureEnabled } from '../../hooks/useFeatureFlag';

const FeatureGate = ({ feature, children, fallback = null }) => {
  if (!isFeatureEnabled(feature)) return fallback;
  return children;
};

export default FeatureGate;
